import React from "react";
import s from "./QReportList.less";
import { Flex } from "antd";
import { LANG } from "~/constans/commom";
import { QReportItem } from "~/widgets/QReportList/ui/QReportItem";

interface IQReportListProps {
  reports: any[];
}

export const QReportList = ({ reports }: IQReportListProps) => {
  let isEn = localStorage.getItem("language") === LANG.en;

  return (
    <Flex className={s.container} vertical>
      {reports.map((report, _idx) => {
        return (
          <QReportItem
            key={report.fileId}
            number={report.number}
            year={report.year}
            link={report.link}
            dealerName={isEn ? report?.dealerNameEn : report?.dealerName}
            inn={report?.inn}
          />
        );
      })}
    </Flex>
  );
};
